import { Component, OnInit, Inject, TemplateRef } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { DatePipe } from '@angular/common';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { WebStorageService, SESSION_STORAGE } from 'ngx-webstorage-service';

import { InventoryCount } from '../../../common/model/InventoryCount';
import { InventoryCountFacade } from '../../../common/facade/InventoryCountFacade';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { InventoryCountTagDetFacade } from '../../../common/facade/InventoryCountTagDetFacade';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';


@Component({
  selector: 'app-inventory-count',
  templateUrl: './inventory-count.component.html',
  styleUrls: ['./inventory-count.component.css']
})
export class InventoryCountComponent implements OnInit {


  titleInventories = res.Inventories;
  lblCreateInventory = res.CreateInventory;
  lblSearch = res.Search;
  lblTitle = res.Title;
  lblStore = res.Store;
  lblDate = res.Date;
  lblCreatedBy = res.CreatedBy;
  lblDivision = res.Division;
  lblSelectAnOption = res.SelectAnOption;
  lblInventoryReference = res.InventoryReference;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  lblCounting = res.Counting;
  lblStockTPV = res.StockTPV;
  lblDifferences = res.Differences;
  lblCost = res.Cost;
  lblTags = res.Tags;
  lblUnsubscribe = res.Unsubscribe;
  lblExport = res.Export;
  lblDelete = res.Delete;
  lblOrganization = res.Organization;
  lblDeleteInventory = res.DeleteInventory;
  lblQuestionDelete = res.MessageDeleteInvetory;
  lblContinue = res.Continue;
  lblCancel = res.Cancel;
  lblDownloadReport = res.DownloadReport;

  errorSmallerThan = res.SmallerDateThan;
  errorGreaterThan = res.GreaterDateThan;

  public txtMinDate = new Date(this.getNowUTC().getFullYear() - 1,
    this.getNowUTC().getMonth(),
    1,
    this.getNowUTC().getHours(),
    this.getNowUTC().getMinutes(),
    this.getNowUTC().getSeconds(),
    this.getNowUTC().getMilliseconds());
  public txtMaxDate = this.getNowUTC();
  public txtStartDate = new Date();
  public txtEndDate = new Date();
  lstOrganization: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  availableOrganizations: Organization[] = [];
  public organizationSelected: any[] = [];
  strOrganizationSelected: string;
  organizationId: string;

  isSpanish = true;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  rowCountInvId = '';
  rowCodeItem = '';

  ModalStore: BsModalRef;
  config = {
    ignoreBackdropClick: true
  };

  loading = false;
  messageLoader = '';
  // alert
  alertsFileExcel = [];
  generalAlerts = [];
  // table
  rows: InventoryCount[] = [];
  private _filteredData: InventoryCount[];
  // filters
  title = -1;
  tmpTitle = -1;
  titles = [];
  store = -1;
  tmpStore = -1;
  stores = [];
  createdFor = '';
  createdFors = [];
  // minDate = new Date();
  fecha = new Date();

  // permissions
  permissionsList: any[] = [];
  visibleAdd = false;
  visibleEdit = false;
  visibleDelete = false;
  tenantId: number = -1;
  stringSelectedOrganizations: string = '';

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _router: Router,
    private _inventoryFacade: InventoryCountFacade,
    private _catalogFacade: CatalogDetFacade,
    private _facadeStore: StoreFacade,
    private _route: ActivatedRoute,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    private inventoryCountTagDetFacade: InventoryCountTagDetFacade,
    private _excel: ExcelUtility,
    public strings: Strings,
    private localeService: BsLocaleService,
    private _datePipe: DatePipe,
  ) {
    this._storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.validatePermissions();
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.localeService.use(this.strings.getLanguage());

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    this.tenantId = this.strings.getTenant();
    this.lstOrganization = this.strings.getAvailableOrganizations().filter(x => x.tenantId == this.tenantId);

    this._route.queryParams.subscribe(params => {
      if (params['startDate'] !== undefined && params['endDate'] !== undefined) {
        this.txtStartDate = new Date(params['startDate']);
        this.txtEndDate = new Date(params['endDate']);
        this.txtMaxDate = new Date(params['endDate']);
      }

      if (params['orgId'] !== undefined) {
        this.organizationId = params["orgId"];
        this.strOrganizationSelected = this.organizationId;
        this.organizationSelected = this.lstOrganization.filter((org) =>
          this.organizationId.includes(org.organizationId)
        );
        this.selectedOrganizations = this.lstOrganization;
        this.getTitles();
        this.getStores();
        this.getInventariosByOrganizationDates();
      }

      if (params['storeId'] !== undefined && params['storeId'] !== -1) {
        this.store = params['storeId']
        this.rows = this._filteredData.filter(item => {
          return (item.storeId.toString() === this.store.toString());
        });
      }

      if (params['titleId'] !== undefined && params['titleId'] !== -1) {
        this.title = params['titleId'];
        this.rows = this._filteredData.filter(item => {
          return (item.catDetType.toString() === this.title.toString());
        });
      }
    });
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  private getStores() {
    this.messageLoader = this.strings.GetText(res.Loading);
    this.stores = [];
    if (this.selectedOrganizations.length > 0) {
      this._facadeStore.GetParticipateQuantum().subscribe(
        response => {
          const stores = response.data;
          if (stores.length > 0) {
            stores.forEach(store => {
              if (this.selectedOrganizations.find(organization => organization.organizationId == store.organizationId) != undefined)
                this.stores.push(store);
            });
          }
        }, error => {
          this.loading = false;
          this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger', 'general');
        }
      );
      this.store = this.store !== -1 && this.store > 0 ? this.store : -1;
    }
  }

  private getTitles() {
    this.messageLoader = this.strings.GetText(res.Loading);

    let language = 0;
    if (!this.isSpanish) {
      language = 1;
    }

    this._catalogFacade.Get(38, language).subscribe(
      response => {
        this.titles = response.data;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTitlesCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String) {
    if (fileType === 'excel') {
      this.alertsFileExcel = [];
      this.alertsFileExcel.push({
        type: type,
        msg: message
      });
    } else {
      this.generalAlerts = [];
      this.generalAlerts.push({
        type: type,
        msg: message
      });
    }

  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, fileType: String): void {
    if (fileType === 'excel') {
      this.alertsFileExcel = this.alertsFileExcel.filter(alert => alert !== dismissedAlert);
    } else {
      this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
    }
  }

  // filters
  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  onTitleChange() {
    this.createdFor = '-1';
    this.fecha = new Date();
    if (this.title.toString() === '-1') {
      if (this.store.toString() !== '-1') {
        this.rows = this._filteredData.filter(item => {
          return (item.storeId.toString() === this.store.toString());
        });
      } else {
        this.rows = this._filteredData;
      }
    } else {
      if (this.store.toString() !== '-1') {
        this.rows = this._filteredData.filter(item => {
          return (item.catDetType.toString() === this.title.toString() && item.storeId.toString() === this.store.toString());
        });
      } else {
        this.rows = this._filteredData.filter(item => {
          return (item.catDetType.toString() === this.title.toString());
        });
      }
    }
    this.loading = false;
  }

  onStoreChange() {
    this.createdFor = '-1';
    this.fecha = new Date();

    if (this.store.toString() === '-1') {
      if (this.title.toString() !== '-1') {
        this.rows = this._filteredData.filter(item => {
          return (item.catDetType.toString() === this.title.toString());
        });
      } else {
        this.rows = this._filteredData;
      }
    } else {
      if (this.title.toString() !== '-1') {
        this.rows = this._filteredData.filter(item => {
          return (item.storeId.toString() === this.store.toString() && item.catDetType.toString() === this.title.toString());
        });
      } else {
        this.rows = this._filteredData.filter(item => {
          return (item.storeId.toString() === this.store.toString());
        });
      }
    }
    this.loading = false;
  }

  // create inventory
  newInventory() {
    if (this.grantedToCreated) {
      this._router.navigate(['/inventory/counts/physical/', 0]);
    } else {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouDoNotHaveThePermissionsToCreate), 'danger', 'general');
    }
  }

  // go toDetail
  onViewDetail(id) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'startDate': this.txtStartDate.toDateString(),
        'endDate': this.txtEndDate.toDateString(),
        'storeId': this.store,
        'titleId': this.title,
        'orgId': this.strOrganizationSelected
      }
    };
    this._router.navigate(['/inventory/counts/physical/detail/', id], navigationExtras);
  }

  // Edit Tags
  onEditTags(id) {
    if (this.grantedToEdit()) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          'orgId': this.strOrganizationSelected,
          'startDate': this.txtStartDate.toDateString(),
          'endDate': this.txtEndDate.toDateString(),
          'storeId': this.store,
          'titleId': this.title
        }
      }

      this._router.navigate(['/inventory/counts/physical/', id], navigationExtras);
    } else {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouDoNotHaveThePermissionsToEdit), 'danger', 'general');
    }
  }
  // Delete inventory
  onDelete(id) {
    if (this.grantedToEdit()) {
      this.deleteInventory(id);
    } else {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouDoNotHaveThePermissionsToRemoveInventory), 'danger', 'general');
    }
    this.closeModal();
  }

  openModal(template: TemplateRef<any>, item: any, code: any) {
    if (!isNullOrUndefined(item)) {
      this.rowCountInvId = item;
      this.rowCodeItem = code;

      this.ModalStore = this.modalService.show(
        template,
        Object.assign({},
          { class: 'gray modal-xl' },
          this.config)
      )
    }

  }

  closeModal() {
    this.modalService.hide();
  }

  grantedToCreated(): boolean {
    const permissionsList = this._storage.get('permissions');
    let granted = false;
    permissionsList.forEach(element => {
      if (element.name === Permissions.GeneralAccess
        || element.name === Permissions.InventarioFisicoCreate
        || element.name === Permissions.InventarioConteoCreate
      ) {
        granted = true;
      }
    });
    return granted;
  }

  grantedToEdit(): boolean {
    const permissionsList = this._storage.get('permissions');
    let granted = false;
    permissionsList.forEach(element => {
      if (element.name === Permissions.GeneralAccess
        || element.name === Permissions.InventarioFisicoEdit
        || element.name === Permissions.InventarioConteoEdit
      ) {
        granted = true;
      }
    });
    return granted;
  }

  downloadReport(item) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.inventoryCountTagDetFacade.GetAllByInvCountId(item.invCountId).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          if (response.data.length > 0) {
            const data: any = [];
            response.data.forEach(row => {
              const info = {
                [this.strings.GetText(res.Product)]: row.description,
                'EAN': row.code,
                [this.strings.GetText(res.Style) + ' ' + this.strings.GetText(res.Variety)]: row.styleVariety,
                [this.strings.GetText(res.Size)]: row.sizeName,
                [this.strings.GetText(res.CountingQuantity)]: row.count,
                [this.strings.GetText(res.Department)]: row.catDetSectionName,
                [this.strings.GetText(res.Gender)]: row.catDetGenderName,
                [this.strings.GetText(res.Brand)]: row.catDetBrandName
              };
              data.push(info);
            });
            this._excel.exportAsExcelFile(data, item.code);
          } else {
            this.addAlert(this.strings.GetText(res.AlertThisInventoryDoesNotHaveCapturedData), 'danger', 'general');
          }
        } else {
          this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertThereWasErrorConsultingDetailInventory), 'danger', 'general');
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertInventoryDataCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  downloadInventoryReport() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    if (this.rows !== undefined && this.rows !== null && this.rows.length > 0) {
      const data: any = [];
      this.rows.sort((a, b) => new Date(b.endDate).getTime() - new Date(a.startDate).getTime());
      this.rows.forEach(row => {
        let info: any;
        if (this.isSpanish) {
          info = {
            [this.strings.GetText(res.InventoryReference)]: row.code,
            [this.strings.GetText(res.Title)]: row.catDetTypeName,
            [this.strings.GetText(res.CreatedBy)]: row.employeeName,
            [this.strings.GetText(res.Division)]: row.divisionNames,
            [this.strings.GetText(res.StartDate)]: this._datePipe.transform(row.startDate, 'dd/MM/yyyy'),
            [this.strings.GetText(res.Deadline)]: this._datePipe.transform(row.endDate, 'dd/MM/yyyy'),
            [this.strings.GetText(res.Store)]: row.storeName,
            [this.strings.GetText(res.Counting)]: row.count,
            [this.strings.GetText(res.StockTPV)]: row.countTPV,
            [this.strings.GetText(res.Differences)]: row.difference,
            [this.strings.GetText(res.Cost)]: row.costDifference,
            [this.strings.GetText(res.Tags)]: row.inventoryCountTagQuantity
          };
        } else {
          info = {
            [this.strings.GetText(res.InventoryReference)]: row.code,
            [this.strings.GetText(res.Title)]: row.catDetTypeName,
            [this.strings.GetText(res.CreatedBy)]: row.employeeName,
            [this.strings.GetText(res.Division)]: row.divisionNames,
            [this.strings.GetText(res.StartDate)]: this._datePipe.transform(row.startDate, 'MM/dd/yyyy'),
            [this.strings.GetText(res.Deadline)]: this._datePipe.transform(row.endDate, 'MM/dd/yyyy'),
            [this.strings.GetText(res.Store)]: row.storeName,
            [this.strings.GetText(res.Counting)]: row.count,
            [this.strings.GetText(res.StockTPV)]: row.countTPV,
            [this.strings.GetText(res.Differences)]: row.difference,
            [this.strings.GetText(res.Cost)]: row.costDifference,
            [this.strings.GetText(res.Tags)]: row.inventoryCountTagQuantity
          };
        }
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.strings.GetText(res.InventoryReport));
      this.loading = false;
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger', 'general');
      this.loading = false;
    }
  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions');
    this.permissionsList.forEach(element => {
      if (element.name == Permissions.GeneralAccess
        || element.name == Permissions.InventarioConteoCreate || element.name == Permissions.InventarioFisicoCreate) {
        this.visibleAdd = true;
      }
    });

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.GeneralAccess
        || element.name == Permissions.InventarioConteoEdit || element.name == Permissions.InventarioFisicoEdit) {
        this.visibleEdit = true;
        this.visibleDelete = true;
      }
    });
  }

  private deleteInventory(id: number) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this._inventoryFacade.DeleteInventoryCount(id).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.addAlert('<strong>' + this.strings.GetText(res.InventoryDeletedSuccessfully) + '</strong>', 'success', 'general');
          this.getInventariosByOrganizationDates();
        } else {
          this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'general');
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertCantDeleteInventory), 'danger', 'general');
      }
    );
    this.loading = false;
  }

  onChangeStartDate(value) {
    this.txtStartDate = this.subtractTimeFromDate(value, 6);
  }

  onChangeEndDate(value) {
    this.txtEndDate = this.subtractTimeFromDate(value, 6);
  }

  getInventariosByOrganizationDates() {
    this.loading = this.loading ? true : true;
    this._filteredData = [];

    if (this.selectedOrganizations.length == 0) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertSelectOrganization), 'danger', 'general');
      this.loading = false;
      return;
    } else {
      this.stringSelectedOrganizations = this.lstOrganization.map(o => o.organizationId).join(',');
    }

    if (new Date(this.txtStartDate) > new Date(this.txtEndDate)) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger', 'general');
      this.loading = false;
    } else {
      let language = 0;
      if (!this.isSpanish) {
        language = 1;
      }
      this._inventoryFacade.GetCollectionInventoryCountByOrganizationDates(this.organizationId, this.datepipe.transform(this.txtStartDate, 'yyyyMMdd_HH:mm:ss') + '.000',
        this.datepipe.transform(this.txtEndDate, 'yyyyMMdd_HH:mm:ss') + '.000', language).subscribe(
          response => {
            this.rows = response.data;
            if (response.data.length > 0) {
              this._filteredData = response.data;
            }

            this.createdFor = '-1';
            this.onStoreChange();
            this.onTitleChange();

            this.loading = false;
          }, error => {
            this.loading = false;
            this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertInventoriesCouldNotBeObtained), 'danger', 'general');
          }
        );
    }
  }

  onChangeOrganization(selected: Organization[]) {
    this.selectedOrganizations = selected;
    this.strOrganizationSelected = this.selectedOrganizations
      .map((e) => e.organizationId)
      .join(",");
    this.organizationId = this.strOrganizationSelected;
    this.getTitles();
    this.getStores();
  }

  search() {
    this.getInventariosByOrganizationDates();
  }

  subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = intHours * 60 * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }
}
